import Image from 'next/image';
import { ArrowRightIcon, IconSize } from '@lifechurch/react-ion';
import styles from './FirstStep.module.css';
import { FC } from 'react';

interface Props {
  number: number;
  iconPath: string;
  title: string;
}

const FirstStep: FC<Props> = ({ number, iconPath, title }) => {
  const justification = number % 2 === 0 ? 'justify-items-end' : 'justify-items-start';
  const marginBottom = number !== 5 ? 'mb-6' : '';
  return (
    <div className={`mx-auto ${marginBottom} lg:mb-0`}>
      <div className={`m-auto max-w-lg grid ${justification} lg:flex`}>
        <div
          className={`rounded bg-gray-5 pt-4 lg:pt-0 ${styles['card-width']} lg:w-auto lg:bg-transparent lg:flex lg:flex-wrap`}
        >
          <div className='absolute -mt-2 font-bold text-left lg:hidden pl-3.5 text-gray-50'>
            {number}
          </div>
          <div className='w-full lg:p-0 pt-4.5 lg:pb-2'>
            <Image src={iconPath} alt={title} layout='fixed' width={64} height={64} />
          </div>
          <div className='w-full lg:grid'>
            <div
              className={`body-detail text-gray-100 pb-4 ${styles['max-w-icon-text']} justify-self-center`}
            >
              {title}
            </div>
          </div>
        </div>
        <div className={`hidden ${number === 5 ? '' : 'lg:inline'} self-start mt-3`}>
          <ArrowRightIcon size={IconSize.XL} />
        </div>
      </div>
    </div>
  );
};

export default FirstStep;
